import React, { FC } from 'react';
import s from './info.module.scss';
import cn from 'classnames';
import { SpriteIcon } from '@components/Sprites/SpriteIcon';
import { useTranslation } from '@hooks/useTranslation';
type InfoProps = {
  valid: boolean;
};
export const Info: FC<InfoProps> = ({
  valid = true
}) => {
  const {
    translate: tr
  } = useTranslation();
  return <div className={cn(s.info, {
    [s.info__error]: !valid
  })} data-sentry-component="Info" data-sentry-source-file="Info.tsx">
            <SpriteIcon className={s.info__icon} height={17} width={17} name='info' data-sentry-element="SpriteIcon" data-sentry-source-file="Info.tsx" />
            <span>
                {tr({
        id: 'post.validate.message'
      })}
            </span>

        </div>;
};